import { InjectionToken, Host, Optional, Inject, Component, NgModule } from '@angular/core';
import { __decorate, __param } from 'tslib';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/sidenav';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/material/menu';

function NavigationComponent_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const route_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", route_r2.path);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(route_r2.data == null ? null : route_r2.data.title);
} }
function NavigationComponent_ng_container_2_ng_container_1_ng_container_2_ng_container_5_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    const route_r2 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("routerLink", route_r2.path + "/" + child_r9.path);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(child_r9.data == null ? null : child_r9.data.title);
} }
function NavigationComponent_ng_container_2_ng_container_1_ng_container_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavigationComponent_ng_container_2_ng_container_1_ng_container_2_ng_container_5_button_1_Template, 2, 2, "button", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", child_r9.data == null ? null : child_r9.data.title);
} }
function NavigationComponent_ng_container_2_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "mat-menu", 6, 7);
    ɵngcc0.ɵɵtemplate(5, NavigationComponent_ng_container_2_ng_container_1_ng_container_2_ng_container_5_Template, 2, 1, "ng-container", 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r7 = ɵngcc0.ɵɵreference(4);
    const route_r2 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("matMenuTriggerFor", _r7)("routerLink", route_r2.path);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(route_r2.data == null ? null : route_r2.data.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("overlapTrigger", false);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", route_r2.children);
} }
function NavigationComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavigationComponent_ng_container_2_ng_container_1_ng_container_1_Template, 3, 2, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(2, NavigationComponent_ng_container_2_ng_container_1_ng_container_2_Template, 6, 5, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const route_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !route_r2.children || route_r2.children && route_r2.children.length == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", route_r2.children && route_r2.children.length > 0);
} }
function NavigationComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavigationComponent_ng_container_2_ng_container_1_Template, 3, 2, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const route_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", route_r2.data == null ? null : route_r2.data.title);
} }
function NavigationComponent_ul_4_ng_container_1_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11);
    ɵngcc0.ɵɵlistener("click", function NavigationComponent_ul_4_ng_container_1_li_1_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ctx_r19.close(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const route_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("routerLink", route_r15.path);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", route_r15.data.title, " ");
} }
function NavigationComponent_ul_4_ng_container_1_ng_container_2_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11);
    ɵngcc0.ɵɵlistener("click", function NavigationComponent_ul_4_ng_container_1_ng_container_2_li_1_Template_li_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(4); return ctx_r24.close(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const child_r23 = ctx.$implicit;
    const route_r15 = ɵngcc0.ɵɵnextContext(3).$implicit;
    ɵngcc0.ɵɵproperty("routerLink", route_r15.path + "/" + child_r23.path);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", child_r23.data.title, " ");
} }
function NavigationComponent_ul_4_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavigationComponent_ul_4_ng_container_1_ng_container_2_li_1_Template, 2, 2, "li", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const route_r15 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", route_r15.children);
} }
function NavigationComponent_ul_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavigationComponent_ul_4_ng_container_1_li_1_Template, 2, 2, "li", 10);
    ɵngcc0.ɵɵtemplate(2, NavigationComponent_ul_4_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const route_r15 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", route_r15.path);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", route_r15.children && route_r15.children.length > 0);
} }
function NavigationComponent_ul_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul");
    ɵngcc0.ɵɵtemplate(1, NavigationComponent_ul_4_ng_container_1_Template, 3, 2, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const route_r15 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", route_r15.data == null ? null : route_r15.data.title);
} }
const NAVIGATION_CONFIG = new InjectionToken('navigation.config');

let NavigationComponent = class NavigationComponent {
    constructor(_sidenav, _config, _router) {
        this._sidenav = _sidenav;
        this._config = _config;
        this._router = _router;
        this._routes = [];
        this._alive = new Subject();
        // Custom config provided?
        if (this._config) {
            // Promise of Route[]?
            if (_config instanceof Promise) {
                _config.then((routes) => this._routes = routes);
            }
            else if (_config instanceof Observable) {
                _config
                    .pipe(takeUntil(this._alive))
                    .subscribe((routes) => this._routes = routes);
            }
            else {
                this._routes = _config;
            }
            // Default, take router routes
        }
        else {
            this._routes = _router.config;
        }
    }
    getRoutes() {
        return this._routes;
    }
    close() {
        if (this._sidenav) {
            this._sidenav.close();
        }
    }
    ngOnDestroy() {
        this._alive.next();
        this._alive.complete();
    }
};
NavigationComponent.ɵfac = function NavigationComponent_Factory(t) { return new (t || NavigationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MatSidenav, 9), ɵngcc0.ɵɵdirectiveInject(NAVIGATION_CONFIG, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router)); };
NavigationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NavigationComponent, selectors: [["ff-navigation"]], decls: 5, vars: 2, consts: [[1, "align-items-end", "desktop"], [4, "ngFor", "ngForOf"], [1, "mobile"], [4, "ngIf"], ["routerLinkActive", "active", 1, "mr-5", 3, "routerLink"], ["routerLinkActive", "active", 1, "mr-5", 3, "matMenuTriggerFor", "routerLink"], [1, "py-3", "px-2", 3, "overlapTrigger"], ["menu", "matMenu"], ["mat-menu-item", "", 3, "routerLink", 4, "ngIf"], ["mat-menu-item", "", 3, "routerLink"], ["class", "pointer", "routerLinkActive", "active", 3, "routerLink", "click", 4, "ngIf"], ["routerLinkActive", "active", 1, "pointer", 3, "routerLink", "click"], ["class", "pointer", "routerLinkActive", "active", 3, "routerLink", "click", 4, "ngFor", "ngForOf"]], template: function NavigationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "ul");
        ɵngcc0.ɵɵtemplate(2, NavigationComponent_ng_container_2_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "nav", 2);
        ɵngcc0.ɵɵtemplate(4, NavigationComponent_ul_4_Template, 2, 1, "ul", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.getRoutes());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.getRoutes());
    } }, directives: [ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc2.RouterLinkActive, ɵngcc2.RouterLink, ɵngcc4.MatMenuTrigger, ɵngcc4.MatMenu, ɵngcc4.MatMenuItem], styles: ["[_nghost-%COMP%]   nav.mobile[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style-type:none;margin:0;padding-left:0;width:100%}[_nghost-%COMP%]   nav.mobile[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;font-family:var(--total-font-helvetica-mdcn);color:var(--total-gray-800);font-size:1rem;min-height:53px;padding:1.5rem 1rem 1.5rem 2.5rem;width:320px;text-transform:uppercase;border:1px solid;border-image-slice:1;border-image-source:linear-gradient(to right,var(--total-gray-600),transparent);background:#fff;border-left:0;border-right:0;border-top:0}[_nghost-%COMP%]   nav.mobile[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]{color:var(--total-red-800)}[_nghost-%COMP%]   nav.mobile[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child{font-size:1.2rem;font-family:var(--total-font-helvetica-bdcn)}[_nghost-%COMP%]   nav.desktop[_ngcontent-%COMP%]{display:none}@media (min-width:62em){[_nghost-%COMP%]   nav.mobile[_ngcontent-%COMP%]{display:none}[_nghost-%COMP%]   nav.desktop[_ngcontent-%COMP%]{display:-webkit-box;display:flex}[_nghost-%COMP%]   nav.desktop[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{list-style-type:none;margin-bottom:0;padding-left:115px}[_nghost-%COMP%]   nav.desktop[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-family:var(--total-font-helvetica-bdcn);display:inline-block;text-transform:uppercase;color:var(--total-gray-800);padding-bottom:17px;cursor:pointer;border-bottom:solid 0 var(--total-red-600);position:relative}[_nghost-%COMP%]   nav.desktop[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]::after{content:\"\";position:absolute;left:0;bottom:0;width:0%;height:5px;background-color:var(--total-red-600);z-index:2;-webkit-transition:width .1s ease-in-out;transition:width .1s ease-in-out}[_nghost-%COMP%]   nav.desktop[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%], [_nghost-%COMP%]   nav.desktop[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{color:var(--total-red-600)}[_nghost-%COMP%]   nav.desktop[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]::after, [_nghost-%COMP%]   nav.desktop[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover::after{width:100%}}"] });
NavigationComponent.ctorParameters = () => [
    { type: MatSidenav, decorators: [{ type: Host }, { type: Optional }] },
    { type: undefined, decorators: [{ type: Inject, args: [NAVIGATION_CONFIG,] }, { type: Optional }] },
    { type: Router }
];
NavigationComponent = __decorate([ __param(0, Host()), __param(0, Optional()),
    __param(1, Inject(NAVIGATION_CONFIG)), __param(1, Optional())
], NavigationComponent);

let NavigationModule = class NavigationModule {
};
NavigationModule.ɵfac = function NavigationModule_Factory(t) { return new (t || NavigationModule)(); };
NavigationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NavigationModule });
NavigationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatIconModule,
            MatMenuModule,
            MatSidenavModule,
            RouterModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavigationComponent, [{
        type: Component,
        args: [{
                selector: 'ff-navigation',
                template: "<nav class=\"align-items-end desktop\">\n    <ul>\n      <ng-container *ngFor=\"let route of getRoutes()\">\n        <ng-container *ngIf=\"route.data?.title\">\n          <!-- No child -->\n          <ng-container *ngIf=\"!route.children || (route.children && route.children.length == 0)\">\n            <li class=\"mr-5\" [routerLink]=\"route.path\" routerLinkActive=\"active\">{{route.data?.title}}</li>\n          </ng-container>\n          <!-- Has children -->\n          <ng-container *ngIf=\"route.children && route.children.length > 0\">\n            <li class=\"mr-5\" [matMenuTriggerFor]=\"menu\" [routerLink]=\"route.path\" routerLinkActive=\"active\">{{route.data?.title}}</li>\n            <mat-menu class=\"py-3 px-2\" #menu=\"matMenu\" [overlapTrigger]=\"false\">\n                <ng-container *ngFor=\"let child of route.children\">\n                    <button mat-menu-item  *ngIf=\"child.data?.title\" [routerLink]=\"route.path + '/' + child.path\">{{child.data?.title}}</button>\n                </ng-container>\n              </mat-menu>\n          </ng-container>\n        </ng-container>\n      </ng-container>\n    </ul>\n  </nav>\n  <nav class=\"mobile\">\n    <ul *ngFor=\"let route of getRoutes()\">\n      <ng-container *ngIf=\"route.data?.title\">\n        <li (click)=\"close()\" class=\"pointer\" routerLinkActive=\"active\" [routerLink]=\"route.path\" *ngIf=\"route.path\">\n          {{route.data.title}}\n        </li>\n        <!-- Has children -->\n        <ng-container *ngIf=\"route.children && route.children.length > 0\">\n            <li (click)=\"close()\" class=\"pointer\" routerLinkActive=\"active\" [routerLink]=\"route.path + '/' + child.path\" *ngFor=\"let child of route.children\">\n              {{child.data.title}}\n            </li>\n        </ng-container>\n      </ng-container>\n    </ul>\n  </nav>\n",
                styles: [":host nav.mobile ul{list-style-type:none;margin:0;padding-left:0;width:100%}:host nav.mobile ul li{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;font-family:var(--total-font-helvetica-mdcn);color:var(--total-gray-800);font-size:1rem;min-height:53px;padding:1.5rem 1rem 1.5rem 2.5rem;width:320px;text-transform:uppercase;border:1px solid;border-image-slice:1;border-image-source:linear-gradient(to right,var(--total-gray-600),transparent);background:#fff;border-left:0;border-right:0;border-top:0}:host nav.mobile ul li.active{color:var(--total-red-800)}:host nav.mobile ul li:first-child{font-size:1.2rem;font-family:var(--total-font-helvetica-bdcn)}:host nav.desktop{display:none}@media (min-width:62em){:host nav.mobile{display:none}:host nav.desktop{display:-webkit-box;display:flex}:host nav.desktop ul{list-style-type:none;margin-bottom:0;padding-left:115px}:host nav.desktop ul li{font-family:var(--total-font-helvetica-bdcn);display:inline-block;text-transform:uppercase;color:var(--total-gray-800);padding-bottom:17px;cursor:pointer;border-bottom:solid 0 var(--total-red-600);position:relative}:host nav.desktop ul li::after{content:\"\";position:absolute;left:0;bottom:0;width:0%;height:5px;background-color:var(--total-red-600);z-index:2;-webkit-transition:width .1s ease-in-out;transition:width .1s ease-in-out}:host nav.desktop ul li.active,:host nav.desktop ul li:hover{color:var(--total-red-600)}:host nav.desktop ul li.active::after,:host nav.desktop ul li:hover::after{width:100%}}"]
            }]
    }], function () { return [{ type: ɵngcc1.MatSidenav, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [NAVIGATION_CONFIG]
            }, {
                type: Optional
            }] }, { type: ɵngcc2.Router }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavigationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatMenuModule,
                    MatSidenavModule,
                    RouterModule
                ],
                declarations: [
                    NavigationComponent
                ],
                exports: [
                    NavigationComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NavigationModule, { declarations: function () { return [NavigationComponent]; }, imports: function () { return [CommonModule,
        MatIconModule,
        MatMenuModule,
        MatSidenavModule,
        RouterModule]; }, exports: function () { return [NavigationComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { NAVIGATION_CONFIG, NavigationModule, NavigationComponent as ɵa };

